export default () => ({
  id: 'breastfeeding',
  label: 'Are you breastfeeding?',
  warn: 'yes',
});
